import React from 'react';
import Slider from './Slider';
import LoginTabs from './LoginTabs';
import { variableName } from '../../../variableName';

const HomeComponent = () => {
    return (
        <>
            <div className='row m-0'>
                <div className='col-md-5 offset-md-1 imageContainer'>
                    <div className='row'>
                        <div className='col-lg-11'>
                            <div className='img text-end'>
                                <Slider />
                            </div>
                        </div>
                    </div>
                </div>

                <div className='col-md-3 col-12 col-sm-12 col' style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                    <div className='loginContainer'>
                        <LoginTabs />
                    </div>
                </div>
            </div>
        </>
    );
};

export default HomeComponent;